
import { Button, IconButton } from '@mui/material';
import './flowersMobile.css';
import flower1 from "../../../../../assets/flowers/camelia.jpeg";
import flower2 from "../../../../../assets/flowers/europiana.jpeg";
import flower211 from "../../../../../assets/flowers/europiana-det.jpeg";
import flower3 from "../../../../../assets/flowers/gardenia.jpeg";
import flower4 from "../../../../../assets/flowers/hibiscus.jpeg";
import flower41 from "../../../../../assets/flowers/hibiscus-det.jpeg";
import flower5 from "../../../../../assets/flowers/hydrangea.jpeg";
import flower51 from "../../../../../assets/flowers/hydra-det.jpeg";
import flower6 from "../../../../../assets/flowers/lavendar.jpeg";
import flower7 from "../../../../../assets/flowers/marigold.jpeg";
import flower8 from "../../../../../assets/flowers/nerium-oleander.jpeg";
import flower9 from "../../../../../assets/flowers/osteo.jpeg";
import flower10 from "../../../../../assets/flowers/rosa-damascena.jpeg";
import flower11 from "../../../../../assets/flowers/Lantana.jpeg";
import flower111 from "../../../../../assets/flowers/lantana-det.jpeg";
import flower12 from "../../../../../assets/flowers/begonia.jpeg";
import flower13 from "../../../../../assets/flowers/dianthus-chinesis.jpeg";
import flower14 from "../../../../../assets/flowers/dianthus.jpeg";
import flower15 from "../../../../../assets/flowers/gazania.jpeg";
import flower151 from "../../../../../assets/flowers/gazania-det.jpeg";
import flower16 from "../../../../../assets/flowers/zinnia.jpeg";
import flower161 from "../../../../../assets/flowers/zennia-det.jpeg";
import flower17 from "../../../../../assets/flowers/sunpatiens.jpeg";
import flower18 from "../../../../../assets/flowers/selvia.jpeg";
import flower19 from "../../../../../assets/flowers/geranium.jpeg";
import flower191 from "../../../../../assets/flowers/geranium-det1.jpeg";
import flower192 from "../../../../../assets/flowers/geranium-det2.jpeg";
import flower193 from "../../../../../assets/flowers/geranium-det3.jpeg";
import flower194 from "../../../../../assets/flowers/geranium-det4.jpeg";
import flower20 from "../../../../../assets/flowers/petunia.jpg";
import flower21 from "../../../../../assets/flowers/petunia-det.jpeg";
import flower22 from "../../../../../assets/flowers/hemigra.jpg";
import flower221 from "../../../../../assets/flowers/hemigraphis-det.jpeg";
import flower23 from "../../../../../assets/flowers/coleus.webp";
import flower231 from "../../../../../assets/flowers/coleus-det.jpeg";
import flower24 from "../../../../../assets/flowers/impatiens.png";
import flower241 from "../../../../../assets/flowers/impatience-det.jpeg";
import flower25 from "../../../../../assets/flowers/Agapanthus.jpg";
import flower26 from "../../../../../assets/flowers/gaura.jpg";
import flower261 from "../../../../../assets/flowers/gaura-det.jpeg";
import flower27 from "../../../../../assets/flowers/cannax.webp";
import flower271 from "../../../../../assets/flowers/canna-det.jpeg";
import flower28 from "../../../../../assets/flowers/verveine.jpg";
import flower281 from "../../../../../assets/flowers/verveine-det.jpeg";
import flower29 from "../../../../../assets/flowers/mandevilla.jpg";
import flower291 from "../../../../../assets/flowers/mandevilla-det.jpeg";
import flower30 from "../../../../../assets/flowers/alternanthera.jpg";
import flower301 from "../../../../../assets/flowers/alternanthera-det.jpeg";
import flower31 from "../../../../../assets/flowers/Tradescantia.jpg";
import flower311 from "../../../../../assets/flowers/tradescantia-det.jpeg";
import flower32 from "../../../../../assets/flowers/fuchsia-regia.jpg";
import flower321 from "../../../../../assets/flowers/fuchsia-regia1.jpeg";
import flower33 from "../../../../../assets/flowers/cuphea.jpg";
import flower331 from "../../../../../assets/flowers/cuphea-det.jpeg";
import flower34 from "../../../../../assets/flowers/bidens.jpg";
import flower341 from "../../../../../assets/flowers/bidens-det.jpeg";

import flower35 from "../../../../../assets/flowers/marguerite-daisy.jpg";
import flower351 from "../../../../../assets/flowers/marguerite-daisy-det.jpeg";
import flower36 from "../../../../../assets/flowers/cilivia.webp";
import flower361 from "../../../../../assets/flowers/cilivia-det.jpeg";

import flower37 from "../../../../../assets/flowers/Coreopsis-grandiflora.jpg";
import flower371 from "../../../../../assets/flowers/cereopsis-det.jpeg";

import BackIcon from '../../../../../components/back/back';
import { useNavigate } from 'react-router-dom';


export const FlowersFamilies = [
    {
        id: 1,
        name: "Camelia",
        img: flower1,
        url: "/flower/camelia",
        description: "Camelia is a beautiful evergreen shrub known for its glossy leaves and elegant, rose-like flowers.",

    },
    {
        id: 2,
        name: "Europeana",
        img: flower2,
        url: "/flower/europeana",
        description: "Europeana roses are deep red, compact floribunda roses with dense clusters of blooms and shiny foliage.",
        gallery: [{ src: flower211 }],

    },
    {
        id: 3,
        name: "Gardenia",
        img: flower3,
        url: "/flower/gardenia",
        description: "Gardenia is a fragrant flowering plant prized for its creamy white blooms and dark green leaves.",

    },
    {
        id: 4,
        name: "Hibiscus",
        img: flower4,
        url: "/flower/hibiscus",
        description: "Hibiscus is a tropical flower with large, showy petals that attract butterflies and hummingbirds.",
        gallery: [{ src: flower41 }],
    },
    {
        id: 5,
        name: "Hydrangea",
        img: flower5,
        url: "/flower/hydrangea",
        description: "Hydrangeas are beloved for their large globe-like flower clusters and changing colors based on soil pH.",
        gallery: [{ src: flower51 }],
    },
    {
        id: 6,
        name: "Lavendar",
        img: flower6,
        url: "/flower/lavendar",
        description: "Lavendar is a fragrant herb known for its calming scent and soft purple flowers.",

    },
    {
        id: 7,
        name: "Marigold",
        img: flower7,
        url: "/flower/marigold",
        description: "Marigolds are cheerful annuals with bright yellow and orange blooms, often used to deter pests in gardens.",

    },
    {
        id: 8,
        name: "Nerium Oleander",
        img: flower8,
        url: "/flower/nerium-oleander",
        description: "Oleander is an evergreen shrub with beautiful but highly toxic flowers, commonly used in landscaping.",

    },
    {
        id: 9,
        name: "Osteospermum",
        img: flower9,
        url: "/flower/osteospermum",
        description: "Also known as African Daisies, these vibrant flowers open wide in the sun and close at night.",

    },
    {
        id: 10,
        name: "Rosa Damascena",
        img: flower10,
        url: "/flower/rosa-damascena",
        description: "Damask rose is known for its fine fragrance and is used in rose oil and water production.",

    },
    {
        id: 11,
        name: "Lantana",
        img: flower11,
        url: "/flower/lantana",
        description: "Lantana is a hardy plant with clusters of brightly colored flowers that change color as they age.",
        gallery: [{ src: flower111 }],
    },
    {
        id: 12,
        name: "Begonia",
        img: flower12,
        url: "/flower/begonia",
        description: "Begonias are versatile, colorful plants ideal for shady gardens and containers.",

    },
    {
        id: 13,
        name: "Dianthus Chinesis",
        img: flower13,
        url: "/flower/dianthus-chinesis",
        description: "Known as Chinese pinks, these flowers feature frilly petals and a sweet clove-like fragrance.",

    },
    {
        id: 14,
        name: "Dianthus Dinamic",
        img: flower14,
        url: "/flower/dianthus-dinamic",
        description: "Dianthus Dinamic offers a compact, colorful display with a long blooming season.",

    },
    {
        id: 15,
        name: "Gazania",
        img: flower15,
        url: "/flower/gazania",
        description: "Gazania is a sun-loving plant with daisy-like flowers in vivid shades of orange, yellow, and pink.",
        gallery: [{ src: flower151 }],
    },
    {
        id: 16,
        name: "Zinnia",
        img: flower16,
        url: "/flower/zinnia",
        description: "Zinnias are colorful, fast-growing flowers that attract butterflies and are perfect for summer gardens.",

    },
    {
        id: 17,
        name: "Sunpatiens",
        img: flower17,
        url: "/flower/sunpatiens",
        description: "Sunpatiens are a hybrid impatiens that thrive in full sun and offer season-long color.",

    },
    {
        id: 18,
        name: "Selvia",
        img: flower18,
        url: "/flower/selvia",
        description: "Selvia, or Salvia, is a vibrant plant known for its spikes of red, blue, or purple flowers.",

    },
    {
        id: 19,
        name: "Geranium",
        img: flower19,
        url: "/flower/geranium",
        description: "Geraniums are hardy plants with colorful blooms and fragrant foliage, great for borders and containers.",
        gallery: [{ src: flower191 },
        { src: flower192 },
        { src: flower193 },
        { src: flower194 },


        ],
    },
    {
        id: 20,
        name: "Petunia",
        img: flower20,
        url: "/flower/petunia",
        description: "Petunias are vibrant and versatile flowers that bloom profusely in garden beds or hanging baskets.",
        gallery: [{ src: flower21 }],
    },
    {
        id: 22,
        name: "Hemigraphis Alternata",
        img: flower22,
        url: "/flower/Hemigraphis",
        description: "Hemigraphis Alternata, also known as Purple Waffle Plant, is prized for its metallic purple foliage and ground-covering ability.",
        gallery: [{ src: flower221 }],
    },
    {
        id: 23,
        name: "Coleus",
        img: flower23,
        url: "/flower/coleus",
        description: "Coleus is known for its vibrant, multicolored foliage and is a popular choice for brightening shady garden spots.",
        gallery: [{ src: flower231 }],
    },
    {
        id: 24,
        name: "Impatiens",
        img: flower24,
        url: "/flower/impatiens",
        description: "Impatiens are shade-loving plants with delicate, colorful blooms that thrive in containers and garden beds.",
        gallery: [{ src: flower241 }],
    },
    {
        id: 25,
        name: "Agapanthus",
        img: flower25,
        url: "/flower/agapanthus",
        description: "Agapanthus, or Lily of the Nile, produces tall, elegant blue or white flowers and is ideal for sunny borders.",
    },
    {
        id: 26,
        name: "Gaura",
        img: flower26,
        url: "/flower/gaura",
        description: "Gaura is a graceful perennial with butterfly-like blooms that flutter in the breeze, adding movement to the garden.",
        gallery: [{ src: flower261 }],
    },
    {
        id: 27,
        name: "Cannax",
        img: flower27,
        url: "/flower/cannax",
        description: "Cannax is a tropical plant with bold, upright leaves and vibrant flowers, perfect for adding dramatic flair.",
        gallery: [{ src: flower271 }],
    },
    {
        id: 28,
        name: "Verveine Hybrid",
        img: flower28,
        url: "/flower/verveine",
        description: "Verveine Hybrids offer continuous blooms in a variety of vivid colors, ideal for sunny hanging baskets and beds.",
        gallery: [{ src: flower281 }],
    },
    {
        id: 29,
        name: "Mandevilla",
        img: flower29,
        url: "/flower/mandevilla",
        description: "Mandevilla is a climbing vine with large, trumpet-shaped flowers that add tropical beauty to trellises and patios.",
        gallery: [{ src: flower291 }],
    },
    {
        id: 30,
        name: "Alternanthera",
        img: flower30,
        url: "/flower/alternanthera",
        description: "Alternanthera is a low-growing ornamental plant with colorful foliage, often used as vibrant edging or groundcover.",
        gallery: [{ src: flower301 }],
    },
    {
        id: 31,
        name: "Tradescantia",
        img: flower31,
        url: "/flower/tradescantia",
        description: "Tradescantia, also known as Wandering Jew, is a trailing plant with striking striped leaves and easy-care nature.",
        gallery: [{ src: flower311 }],
    },
    {
        id: 32,
        name: "Fuchsia regia",
        img: flower32,
        url: "/flower/fuchsia-regia",
        description: "Fuchsia regia is a vibrant flowering plant known for its pendulous, tubular flowers in shades of pink, red, and purple. It thrives in partial shade and adds a splash of color to gardens and hanging baskets.",
        gallery: [{ src: flower321 }],
    },
    {
        id: 33,
        name: "Cuphea",
        img: flower33,
        url: "/flower/cuphea",
        description: "Cuphea, commonly known as cigar plant or firecracker plant, is a tropical flowering plant with tubular flowers in vibrant shades of red, orange, and purple. It attracts hummingbirds and thrives in sunny locations with well-drained soil.",
        gallery: [{ src: flower331 }],
    },
    {
        id: 34,
        name: "Bidens",
        img: flower34,
        url: "/flower/bidens",
        description: "Bidens is a cheerful flowering plant known for its bright yellow, daisy-like blooms. It thrives in full sun, attracts pollinators like bees and butterflies, and is ideal for gardens, borders, and containers.",
        gallery: [{ src: flower341 }],
    },
    {
        id: 35,
        name: "Marguerite Daisy",
        img: flower35,
        url: "/flower/marguerite-daisy",
        description: "Marguerite Daisy is a classic flowering plant with elegant white or pastel blooms and a bright yellow center. It thrives in full sun, blooms abundantly from spring to fall, and is perfect for gardens, borders, and pots.",
        gallery: [{ src: flower351 }],
    },
    {
        id: 36,
        name: "Clivia",
        img: flower36,
        url: "/flower/clivia",
        description: "Clivia is an elegant flowering plant known for its vibrant orange or red trumpet-shaped blooms and dark green strap-like leaves. It thrives in partial shade and is ideal for indoor pots or shaded garden areas.",
        gallery: [{ src: flower361 }],
    },
    {
        id: 37,
        name: "Coreopsis grandiflora",
        img: flower37,
        url: "/flower/coreopsis-grandiflora",
        description: "Coreopsis grandiflora is a cheerful perennial plant with bright yellow, daisy-like flowers. It blooms from early summer to fall, thrives in full sun, and is perfect for borders, garden beds, and pollinator-friendly landscapes.",
        gallery: [{ src: flower371 }],
    }


];







export default function FlowersCategorieMobile() {
    const navigate = useNavigate();

    const handleClick = (name: any) => {
        navigate(`/flowers/${name}`);
    };

    return (
        <div className="ficus-container-mobile">
            <BackIcon />
            <div className="title-overlay">
                <div className="title-with-flowers">
                    {/* <span className="flower">🌸</span> */}
                    <h1>Flowers Collection</h1>
                    {/* <span className="flower">🌸</span> */}
                </div>
            </div>

            <div className="plants-category-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8" style={{ marginTop: "2rem" }}>
                {FlowersFamilies.map((flower) => (
                    <div key={flower.id} onClick={() => handleClick(flower.name)} className=" ficus-shape-card bg-white p-6 rounded-xl shadow-lg transform transition-all hover:scale-105" >
                        <img
                            src={flower.img}
                            alt={flower.name}
                            className="w-full h-60 object-cover rounded-lg mb-4"
                        />
                        <p className="plant-name">{flower.name}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
